import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Table, DropdownButton, Dropdown, Form, Modal, Row, Col, Button, Spinner } from 'react-bootstrap';
import { FaSortUp, FaSortDown, FaPlus } from 'react-icons/fa';
import LoadingTableBox from '../components/LoadingTableBox';
import MessageBox from '../components/MessageBox';
import { Link } from 'react-router-dom';
import Paginator from '../screens/Paginator/Paginator';
import moment from 'moment';
import Pagination from './Pagination';
import { downloadExcel } from 'react-export-table-to-excel';
import { FaFileExcel } from 'react-icons/fa';
import './DynamicListTableNew.css';
import {  BsChevronLeft } from 'react-icons/bs';
import classnames from 'classnames';
import { usePermissions } from '../hooks/usePermissions';
import { objectsTranslation, parsePeriodicity } from '../utils';
import { ROLE_OPTIONS } from '../constants/roles';
import { resolveBillCurrency } from '../screens/Balance/balanceTotals';

const DynamicListTable = ({
	dataName, //DataName for customization
	data,//database (current page)
	allData,//full unpaginated dataset for export
	loading, //for loading spinner
	error,//for Error messageBox
	columnInfo, 
	/* 	Example for columnInfo:[
		{ customId:{type: 'string', label: 'ID', link:true }},
		{ 'debtDue.customId':{type: 'string', label: 'Cuota'}},
		{ amount:{type: 'currency', label: 'Monto'}},
		{ date:{type: 'date', label: 'Fecha'}},
		{ folder:{type: 'string', label: 'Carpeta'}},
		{ observations:{type: 'string', label: 'Observaciones', toExport: true }}
	] */
	count, //for paginator if its from queries filter
	onPageChange, //for paginator if its from queries filter
	page, //for paginator if its from queries filter
	pageSize, //for paginator if its from queries filter
	handleSort, //for central lists, ordering function
	direction,
	sortColumn,
	actionButtons, //seeDetails,editHandler,editDateHandler,seeAttachment and deleteHandler
	showCheckboxColumn, //first column with checkboxes
	frontPaginator, //frontPaginator, set to true if is only frontend 
	posts,//set postsPerPage if its front paginator
	exportOption,//export button for xls, with modal, if you want to export some fields but not to show in the screen, set it toExport to True in every field you want
	selectedFieldToExport,//default selectedField to Export, it always be exported to xls, it can be _id or name for example
	filterComponent,
	className,
	handleAdd,
	fetchExportData,
}) => {

	const { canSee, canEdit, canCreate, canDelete } = usePermissions();

	// hide if only "Ver detalles" is available (users can click name links)
	const shouldShowActionColumn = () => {
		if (!actionButtons) return false;
		const hasEditAction = actionButtons.editHandler && canEdit();
		const hasEditDateAction = actionButtons.editDateHandler && canEdit();
		const hasDeleteAction = actionButtons.deleteHandler && canDelete();
		const hasSeeDetails = actionButtons.seeDetails && canSee();
		const hasSeeAttachment = actionButtons.seeAttachment && canSee();
		const hasConfirmPayment = actionButtons.confirmPayment && canEdit();
		const hasApplySurcharge = actionButtons.applySurcharge && canEdit();
		const hasAddPayment = actionButtons.addPayment && canEdit();
		const hasSendReminder = actionButtons.sendReminder && canEdit();
		if (hasSeeDetails && !hasEditAction && !hasEditDateAction && !hasDeleteAction && !hasSeeAttachment && !hasConfirmPayment && !hasApplySurcharge && !hasAddPayment && !hasSendReminder) {
			return false;
		}
		return hasSeeDetails || hasEditAction || hasEditDateAction || hasDeleteAction || hasSeeAttachment || hasConfirmPayment || hasApplySurcharge || hasAddPayment || hasSendReminder;
	};

	const location = useLocation();
	const isReportsScreen = location.pathname.includes('/AdminScreen/reports'); 
	//data to show, column mappings
	const columnMap = {};
	const columns = [];
	const types = {};
	const links= {};
	const linkPaths ={};

	//data for export
	let columnInfoToShow = columnInfo;
	let columnInfoToExport = {};
	const columnMapExport = {};
	const columnsExport = [];
	const typesExport = {};

	columnInfoToShow.forEach((col) => {
		const key = Object.keys(col)[0];
		if (col[key].toExport || col[key].forReport && !isReportsScreen) {
			return;
		}
		columnMap[key] = col[key].label;
		columns.push(key);
		types[key] = col[key].type;
		links[key] =col[key].link;
		linkPaths[key]=col[key].linkPath;
	});

	if(exportOption){
		columnInfoToExport = columnInfo;
		columnInfoToExport.forEach((col) => {
			const key = Object.keys(col)[0];
			columnMapExport[key] = col[key].label;
			columnsExport.push(key);
			typesExport[key] = col[key].type;
		});}

	//gotaccount specific Cases	with currency
	const showCurrency = (currency, value) => {
		if (currency === 'UYU') {
			return '$U ' + value;
		} else if (currency === 'USD') {
			return 'U$S ' + value;
		} else {
			return value;
		}
	};

	/* 
	function to get the value to show based in the type specification from columnInfo.
	if it is date it will show DD-MM-YYYY format
	if it is boolean it will show YES or Node
	if it is currency it will show the currency of the database with the value
	if is setted to link:true, it will show as a link, also you can set linkPath in columnInfo
	the rest of types will only show the original value */

	function getFormattedValue(item, column) {
		// Bills may carry their own currency; the column path points at the asset's.
		if (dataName === 'bills' && column === 'asset.currency') {
			return resolveBillCurrency(item) || 'N/A';
		}
		const keys = column.split('.');
		let nestedValue = item;
		let type = (types[column]);
		for (const key of keys) {
			if (
				nestedValue &&
            nestedValue[key] !== undefined &&
            nestedValue[key] !== 0 &&
            nestedValue[key] !== null &&
            nestedValue[key] !== ''
			) {
				nestedValue = nestedValue[key];
			} else {
				return 'N/A';
			}
		}
		if (column === 'periodicity') {
			return parsePeriodicity(nestedValue.toString());
		}
		if (column === 'role') {
			const roleOption = ROLE_OPTIONS.find((option) => option.value === nestedValue);
			return roleOption ? roleOption.label : nestedValue;
		}
		if (type === 'boolean') {
			// Special case for bills: check both paid and confirmed
			if (dataName === 'bills' && column === 'paid') {
				return (item.paid || item.confirmed) ? 'Si' : 'No';
			}
			return nestedValue ? 'Si' : 'No';
		} 
		
		if (type === 'date') {
			const date = moment.utc(nestedValue);
			return date.isValid() ? date.format('DD-MM-YYYY') : 'N/A';
		}
		if (type === 'currency') {
			// Handle exceptions for currency for gotaccount
			switch (dataName) {
			case 'relWarranties':
				return showCurrency(item.warranty.debt.currency || item.warranty.asset.currency, nestedValue);
			case 'bills':
				return showCurrency(resolveBillCurrency(item), nestedValue || nestedValue);
			case 'debtDues':
				return showCurrency(item.debt?.currency, nestedValue || nestedValue );
			case 'creditDues':
				return showCurrency(item.credit?.currency, nestedValue || nestedValue);
			default:
				return showCurrency(item.currency, nestedValue);
			}
		}  if (links[column]){
			// Check if user has permission to see/view content before rendering links
			if (!canSee()) {
				return nestedValue || 'N/A';
			}
			// usar ruta especifica para link
			if (linkPaths[column]) {
				return (
					<Link to={linkPaths[column]}>
						{nestedValue}
					</Link>
				);
			//caso específico gotaccount
			} else if (links[column] && column === 'owner.name') {
				const linkValue = getFormattedValue(item, 'owner._id');
				return <Link to={`/AdminScreen/accounts/account/${linkValue}`}>{nestedValue}</Link>;
			//casos genericos
			} else {
				const linkValue = getFormattedValue(item, '_id');
				return <Link to={`/AdminScreen/${dataName}/${dataName.slice(0, -1)}/${linkValue}`}>{nestedValue}</Link>;
			}
		}
		return nestedValue || 'N/A';

	}

	//the formating for export only includes date, and boolean
	function getFormattedValueExport(item, column) {
		const keys = column.split('.');
		let nestedValue = item;
		let type = (types[column]);
		for (const key of keys) {
			if (
				nestedValue &&
            nestedValue[key] !== undefined &&
            nestedValue[key] !== 0 &&
            nestedValue[key] !== null &&
            nestedValue[key] !== ''
			) {
				nestedValue = nestedValue[key];
			} else {
				return 'N/A';
			}
		}
		if (type === 'boolean') {
			return nestedValue ? 'Si' : 'No';
		} else if (type === 'date') {
			const isValidDateFormat = moment.utc(nestedValue, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).isValid();
			if (isValidDateFormat) {
				return moment.utc(nestedValue).format('DD-MM-YYYY');
			}
			return 'N/A';
		}  else if (!nestedValue) {
			return 'N/A';}
		return nestedValue;
	}
	
	//to export
	const defaultSelectedField = selectedFieldToExport || 'customId';
	const [selectedFields, setSelectedFields] = useState([defaultSelectedField]);//default selectedField
	const [exportName, setExportName] = useState('');
	const [exporting, setExporting] = useState(false);
	const todayDate = moment.utc().format('DD-MM-YYYY');
	const handleClose = () => {
		if (exporting) return;
		setShow(false);
	};
	const handleShow = () => setShow(true);
	const [show, setShow] = useState(false);

	const handleDownloadExcel = async () => {
		setExporting(true);
		try {
			const selectedColumnMap = columnMapExport;
			const header = selectedFields.map((field) => selectedColumnMap[field]);
			const exportSource = fetchExportData
				? await fetchExportData()
				: (allData && allData.length ? allData : data);
			const body = exportSource.map((item) =>
				selectedFields.map((field) => getFormattedValueExport(item, field, typesExport[field])),
			);
			downloadExcel({
				fileName: exportName ? `${exportName}` : `${todayDate}- ${dataName}`,
				sheet: 'react-export-table-to-excel',
				tablePayload: {
					header,
					body,
				},
			});
			setShow(false);
		} finally {
			setExporting(false);
		}
	};

	const handleSelectAllExportFields = (checked) => {
		setSelectedFields(checked ? columnsExport : [defaultSelectedField]);
	};

	const handleSelectExportField = (field, checked) => {
		setSelectedFields((prevSelectedFields) =>
			checked
				? [...new Set([...prevSelectedFields, field])]
				: prevSelectedFields.filter((selectedField) => selectedField !== field),
		);
	};

	const allExportFieldsSelected = columnsExport.length > 0 && columnsExport.every((column) => selectedFields.includes(column));

	//show two colums of checkboxes in modal for export
	const columnsPerRow = 2;

	const rows = Array.from(
		{ length: Math.ceil(columnsExport.length / columnsPerRow) },
		(_, rowIndex) =>
			columnsExport.slice(rowIndex * columnsPerRow, (rowIndex + 1) * columnsPerRow),
	);

	//checkboxes column, se usa en el caso de alquileres
	async function toggleAllCheckboxes() {
		let allCheckboxes = document.getElementById('allCheckboxes');
		let checkboxes = document.getElementsByName(`checked${dataName}`);
		for (let i = 0; i < checkboxes.length; i++) {
			allCheckboxes.checked ? (checkboxes[i].checked = true) : (checkboxes[i].checked = false);
		}
	}

	//manage frontend pagination
	const [currentPage, setCurrentPage] = useState(1);
	const [postsPerPage] = useState(posts? posts : 5); //maxPostsperPage
	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;
	const currentPosts = data.slice(indexOfFirstPost, indexOfLastPost);
	const tableRef = React.useRef(null);
	//change page
	const paginate = (pageNumber) => setCurrentPage(pageNumber);


	// Check if we have no data and should show empty message
	const shouldShowEmptyMessage = !loading && !error && data.length === 0;

	return (
		<>
			{shouldShowEmptyMessage ? (
				<div className='d-flex justify-cpontent-center flex-column align-items-center'>
					No se encontraron {objectsTranslation[dataName] || 'resultados'}
					{handleAdd && canCreate() && (
						<Button
							size={'sm'}
							className='mt-2'
							onClick={handleAdd}
						>
							<FaPlus /> Agregar nuevo
						</Button>
					)}
				</div>
			) : (
				<>
					{exportOption ? (
						<div className=' m-3'>
							<Row>
								<Col className='d-flex justify-content-end'>
									<Button
										size={'sm'}
										className='mb-1 '
										onClick={handleShow}
										style={{ backgroundColor: 'Green' }}
									>
										<FaFileExcel></FaFileExcel> Exportar
									</Button>
									{ handleAdd && canCreate() && <Button
										size={'sm'}
										className='ms-1 '
										onClick={handleAdd}
									>
										<FaPlus /> Agregar
									</Button>}
								</Col>
							</Row>
							<Modal show={show} onHide={handleClose} backdrop={exporting ? 'static' : true} keyboard={!exporting}>
								<Modal.Header closeButton={!exporting}>
									<Modal.Title>Exportar datos</Modal.Title>
								</Modal.Header>
								<Modal.Body>
									<Form.Group as={Row} className='mb-3 align-items-center'>
										<Form.Label column md={6}>
									Nombre del archivo:
										</Form.Label>
										<Col>
											<Form.Control
												type='text'
												placeholder='Ingrese el nombre'
												value={exportName}
												disabled={exporting}
												onChange={(e) => setExportName(e.target.value)}
											/>
										</Col>
									</Form.Group>
									<>
										<p>Marque los campos que desea incluir</p>
										<Form.Group className='mb-3' controlId={`selectAllExportFields_${dataName}`}>
											<Form.Check
												type='checkbox'
												label='Seleccionar todos los campos'
												checked={allExportFieldsSelected}
												disabled={exporting}
												onChange={(e) => handleSelectAllExportFields(e.target.checked)}
											/>
										</Form.Group>
										{rows.map((row, rowIndex) => (
											<Row key={rowIndex}>
												{row.map((column) => (
													<Col key={column} md={6}>
														<Form.Group
															as={Row}
															className='mb-3 align-items-center'
															controlId={`fieldsToInclude_${column}`}
														>
															<Form.Check
																className='col-8'
																type='checkbox'
																value={column}
																label={columnMapExport[column]}
																checked={selectedFields.includes(column)}
																disabled={exporting || column === defaultSelectedField}//default selected field, can be _id
																onChange={(e) => handleSelectExportField(column, e.target.checked)}
															/>
														</Form.Group>
													</Col>
												))}
											</Row>
										))}
									</>
								</Modal.Body>
								<Modal.Footer>
									<Button variant='secondary' onClick={handleClose} disabled={exporting}>
								Cancelar
									</Button>
									<Button variant='primary' onClick={handleDownloadExcel} disabled={exporting}>
										{exporting ? (
											<>
												<Spinner animation='border' size='sm' className='me-2' />
												Exportando...
											</>
										) : (
											'Exportar XLS'
										)}
									</Button>
								</Modal.Footer>
							</Modal>
						</div>
					) : null}
					<Table ref={tableRef} className={classnames('dynamic-list-table', { [className]: className })} responsive size='sm'>
				
						{filterComponent}
						<thead>
							<tr>
								{showCheckboxColumn && canEdit() ? (
									<th className='last-col'>
										<Form.Check
											type={'checkbox'}
											id='allCheckboxes'
											onClick={() => toggleAllCheckboxes()}
										></Form.Check>
									</th>
								) : null}
								{columns.map((column) => (
									<th key={column} onClick={frontPaginator ? null : handleSort? () => handleSort(column):null}>
										{columnMap[column]}
										{column === sortColumn && (
											<span>{direction === 'desc' ? <FaSortUp /> : <FaSortDown />}</span>
										)}
									</th>
								))}
								{shouldShowActionColumn() ? <th className='last-col text-center'></th> : null}
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan={5}>
										<LoadingTableBox loading={loading} />
									</td>
								</tr>
							) : error ? (
								<tr colSpan={5}>
									<td colSpan={5}>
										<MessageBox variant='danger'>{error}</MessageBox>
									</td>
								</tr>
							) : data.length === 0 ? (
								<tr colSpan={10}>
									<td colSpan={10}>
										{/* <MessageBox variant="light">No hay resultados, si desea crear haga click <Link className="alert-link" to="/AdminScreen/newAccount">aquí</Link></MessageBox> */}
									</td>
								</tr>
							) : frontPaginator ? (
								currentPosts.map((item) => (
									<tr key={item._id}>
										{showCheckboxColumn && canEdit() ? (
											<td>
												<Form.Check
													type={'checkbox'}
													name={`checked${dataName}`}
													value={item._id}
													id={`checked${dataName}`}
												/>
											</td>
										) : null}
										{columns.map((column) => (
											<td key={column}>
												{getFormattedValue(item, column)}
											</td>
										))}
										{shouldShowActionColumn() ? (
											<td>
												<DropdownButton drop='start' title=''>
													{actionButtons.seeDetails && canSee() && (
														<Dropdown.Item eventKey='1' onClick={() => actionButtons.seeDetails(item)}>
													Ver Detalles
														</Dropdown.Item>
													)}
													{actionButtons.editHandler && canEdit() && (
														<Dropdown.Item eventKey='2' onClick={() => actionButtons.editHandler(item)}>
													Editar
														</Dropdown.Item>
													)}
													{actionButtons.editDateHandler && canEdit() && (
														<Dropdown.Item eventKey='2' onClick={() => actionButtons.editDateHandler(item)}>
													Editar Fecha de Inicio
														</Dropdown.Item>
													)}
													{(actionButtons.seeAttachment && item.escritura && canSee()) ||
												(item.comprobante && canSee() && (
													<Dropdown.Item
														eventKey='3'
														onClick={() => actionButtons.seeAttachment(item)}
													>
														Ver Documento
													</Dropdown.Item>
												))}
													{actionButtons.applySurcharge && canEdit() && (
														<Dropdown.Item
															eventKey='5'
															onClick={() => actionButtons.applySurcharge(item)}
														>
													Aplicar Recargo
														</Dropdown.Item>
													)}
													{actionButtons.addPayment && canEdit() && (
														<Dropdown.Item
															eventKey='6'
															onClick={() => actionButtons.addPayment(item)}
														>
													Agregar cobro
														</Dropdown.Item>
													)}
													{actionButtons.confirmCount && canEdit() && item.billingStatus === 'pendingCount' && (
														<Dropdown.Item
															eventKey='8'
															onClick={() => actionButtons.confirmCount(item)}
														>
													Confirmar usuarios
														</Dropdown.Item>
													)}
													{actionButtons.sendReminder && canEdit() && (
														<Dropdown.Item
															eventKey='7'
															onClick={() => actionButtons.sendReminder(item)}
														>
													Enviar recordatorio
														</Dropdown.Item>
													)}
													{actionButtons.deleteHandler && canDelete() && (
														<Dropdown.Item
															eventKey='3'
															onClick={() => actionButtons.deleteHandler(item)}
														>
													Eliminar
														</Dropdown.Item>
													)}
												</DropdownButton>
											</td>
										) : null}
									</tr>
								))
							) : data && !frontPaginator ? (
								data.map((item) => (
									<tr key={item._id}>
										{showCheckboxColumn && canEdit() ? (
											<td>
												<Form.Check
													type={'checkbox'}
													name={`checked${dataName}`}
													value={item._id}
													id={`checked${dataName}`}
												/>
											</td>
										) : null}
										{columns.map((column) => (
											<td key={column}>
												{getFormattedValue(item, column)}
											</td>
										))}
										{shouldShowActionColumn() ? (
											<td className='actions'>
												<Dropdown>
													<Dropdown.Toggle className='object-icon-filter-dropdown'>
														<BsChevronLeft   className='chevron'/>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														{actionButtons.seeDetails && canSee() && (
															<Dropdown.Item eventKey='1' onClick={() => actionButtons.seeDetails(item)}>
													Ver detalles
															</Dropdown.Item>
														)}
														{actionButtons.editHandler && canEdit() && (
															<Dropdown.Item eventKey='2' onClick={() => actionButtons.editHandler(item)}>
													Editar
															</Dropdown.Item>
														)}
														{actionButtons.editDateHandler && canEdit() && (
															<Dropdown.Item eventKey='2' onClick={() => actionButtons.editDateHandler(item)}>
													Editar Fecha de Inicio
															</Dropdown.Item>
														)}
														{(actionButtons.seeAttachment && item.escritura && canSee()) ||
												(item.comprobante && canSee() && (
													<Dropdown.Item
														eventKey='3'
														onClick={() => actionButtons.seeAttachment(item)}
													>
														Ver documento
													</Dropdown.Item>
												)														)}
														{actionButtons.confirmPayment && canEdit() && (
															<Dropdown.Item
																eventKey='4'
																onClick={() => actionButtons.confirmPayment(item)}
																disabled={item.paid || item.confirmed}
															>
														Confirmar Pago
															</Dropdown.Item>
														)}
														{actionButtons.applySurcharge && canEdit() && (
															<Dropdown.Item
																eventKey='5'
																onClick={() => actionButtons.applySurcharge(item)}
															>
														Aplicar Recargo
															</Dropdown.Item>
														)}
														{actionButtons.addPayment && canEdit() && (
															<Dropdown.Item
																eventKey='6'
																onClick={() => actionButtons.addPayment(item)}
															>
															Agregar cobro
															</Dropdown.Item>
														)}
														{actionButtons.sendReminder && canEdit() && (
															<Dropdown.Item
																eventKey='7'
																onClick={() => actionButtons.sendReminder(item)}
															>
															Enviar recordatorio
															</Dropdown.Item>
														)}
														{actionButtons.deleteHandler && canDelete() && (
															<Dropdown.Item
																eventKey='3'
																onClick={() => actionButtons.deleteHandler(item)}
															>
													Eliminar
															</Dropdown.Item>
														)}
													</Dropdown.Menu>
												</Dropdown>
											</td>
										) : null}
									</tr>
								))
							) : null}
						</tbody>
					</Table>
					<></>
					{frontPaginator ? (
						<Pagination
							postsPerPage={postsPerPage}
							totalPosts={data.length}
							paginate={paginate}
						></Pagination>
					) : (
						<Paginator
							className='pagination-bar'
							totalCount={count}
							onPageChange={onPageChange}
							currentPage={parseInt(page)}
							pageSize={pageSize}
						></Paginator>
					)}
				</>
			)}
		</>
	);
};

export default DynamicListTable;
